import component from './component';

const Dropdown = component;

export default component;

export { component, Dropdown };
